import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProfessionalPositionInterface } from '../data';
import { ProfessionalPositionProvider } from '../providers/professional-position.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetProfessionalPositionsUseCase implements UseCase<Observable<Transaction<ProfessionalPositionInterface[]>>> {
    constructor(private professionalPositionProvider: ProfessionalPositionProvider) {}

    bind(): Observable<Transaction<ProfessionalPositionInterface[]>> {
        return this.professionalPositionProvider.find();
    }
}
